var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.videos),function(video,index){return _c('b-col',{key:index,staticClass:"mb-3 video-item",attrs:{"cols":"6","md":"3"},on:{"click":function($event){return _vm.swVideo(video)}}},[_c('b-img',{attrs:{"src":`https://img.youtube.com/vi/${video.ytId}/0.jpg`,"fluid":""}}),_c('h3',[_vm._v(_vm._s(video.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }